module.exports = __webpack_public_path__ + "static/media/visual-story-icon3.4f93ea65.svg";